/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { deleteResultCodes } from '../fn/result-codes/delete-result-codes';
import { DeleteResultCodes$Params } from '../fn/result-codes/delete-result-codes';
import { ResultCode } from '../models/result-code';
import { resultCodes } from '../fn/result-codes/result-codes';
import { ResultCodes$Params } from '../fn/result-codes/result-codes';
import { saveResultCodes } from '../fn/result-codes/save-result-codes';
import { SaveResultCodes$Params } from '../fn/result-codes/save-result-codes';

@Injectable({ providedIn: 'root' })
export class ResultCodesService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `resultCodes()` */
  static readonly ResultCodesPath = '/resultcodes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `resultCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  resultCodes$Response(params?: ResultCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ResultCode>>> {
    const obs = resultCodes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `resultCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  resultCodes(params?: ResultCodes$Params, context?: HttpContext): Observable<Array<ResultCode>> {
    const resp = this.resultCodes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<ResultCode>>): Array<ResultCode> => r.body)
    );
  }

  /** Path part for operation `saveResultCodes()` */
  static readonly SaveResultCodesPath = '/resultcodes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `saveResultCodes()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveResultCodes$Response(params: SaveResultCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultCode>> {
    const obs = saveResultCodes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `saveResultCodes$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  saveResultCodes(params: SaveResultCodes$Params, context?: HttpContext): Observable<ResultCode> {
    const resp = this.saveResultCodes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ResultCode>): ResultCode => r.body)
    );
  }

  /** Path part for operation `deleteResultCodes()` */
  static readonly DeleteResultCodesPath = '/resultcodes';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteResultCodes()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteResultCodes$Response(params: DeleteResultCodes$Params, context?: HttpContext): Observable<StrictHttpResponse<ResultCode>> {
    const obs = deleteResultCodes(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `deleteResultCodes$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteResultCodes(params: DeleteResultCodes$Params, context?: HttpContext): Observable<ResultCode> {
    const resp = this.deleteResultCodes$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<ResultCode>): ResultCode => r.body)
    );
  }

}
